import { Component, input, InputSignal } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

import { ReferralInputWithRevertComponent } from '../Input-With-Revert/referralInputWithRevert.component';
import { ReferralPageService } from '../referralPage.service';

@Component({
    selector: 'referral-scope-of-appeal',
    templateUrl: 'scopeOfAppeal.component.html',
    styleUrls: ['../referralPage.component.scss'],
    imports: [ReactiveFormsModule, ReferralInputWithRevertComponent],
})
export class ReferralScopeOfAppealComponent {
    constructor(private readonly _referralPageService: ReferralPageService) {}
    referral: InputSignal<Core.LitigationReferralModel> = input<Core.LitigationReferralModel>();
    systemReferral: InputSignal<Core.LitigationReferralModel> = input<Core.LitigationReferralModel>();
    originalReferral: InputSignal<Core.LitigationReferralModel> = input<Core.LitigationReferralModel>();
    form: InputSignal<FormGroup> = input<FormGroup>();
    editMode = this._referralPageService.editMode;
}
